"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CheckboxIndeterminateIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><rect width="8" height="2" x="8" y="11" fill="inherit" rx="1"/></g></svg>`
}, props));
CheckboxIndeterminateIcon.displayName = 'CheckboxIndeterminateIcon';
var _default = exports.default = CheckboxIndeterminateIcon;